import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.css']
})
export class FormFieldComponent implements OnInit {
  @Input() label = '';
  @Input() isLoading = false;
  @Input() size = '4';
  @Input() width = null;
  @Input() noPadding = false;
  @Input() required = false;
  @Input() showLabel = true;

  constructor() { }

  ngOnInit() {
  }

}
